/* eslint-disable @typescript-eslint/no-explicit-any */
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack, Typography } from '@mui/material';
import { IChecklistTemplateSection } from '../types';
import { EditableSectionNode } from './ChecklistTemplateItemEditor';

interface ChecklistTemplateSectionEditorProps {
  sections: IChecklistTemplateSection[] | any[];
  onChangeSections: (updatedSections: any[]) => void;
}

export const ChecklistTemplateSectionEditor = ({
  sections = [],
  onChangeSections
}: ChecklistTemplateSectionEditorProps) => {
  const handleAddSection = () => {
    const newSection = {
      id: `sec_${Date.now()}`,
      title: 'Nuova Sezione',
      items: []
    };
    onChangeSections([...sections, newSection]);
  };

  const handleRenameSection = (sectionId: string, newTitle: string) => {
    const updated = sections.map((sec) =>
      sec.id === sectionId ? { ...sec, title: newTitle } : sec
    );
    onChangeSections(updated);
  };

  const handleRemoveSection = (sectionId: string) => {
    const updated = sections.filter((sec) => sec.id !== Number(sectionId));
    onChangeSections(updated);
  };

  const handleAddItemToSection = (sectionId: string) => {
    const newItem = {
      id: `item_${Date.now()}`,
      name: 'Nuovo elemento della checklist',
      is_completed: false
    };

    const updated = sections.map((sec) => {
      if (sec.id === sectionId) {
        return {
          ...sec,
          items: Array.isArray(sec.items) ? [...sec.items, newItem] : [newItem]
        };
      }
      return sec;
    });
    onChangeSections(updated);
  };

  const handleRenameItem = (sectionId: string, itemId: string, newName: string) => {
    const updated = sections.map((sec) => {
      if (sec.id === sectionId) {
        return {
          ...sec,
          items: (sec.items || []).map((item: any) =>
            item.id === itemId ? { ...item, name: newName } : item
          )
        };
      }
      return sec;
    });
    onChangeSections(updated);
  };

  const handleRemoveItemFromSection = (sectionId: string, itemId: string) => {
    const updated = sections.map((sec) => {
      if (sec.id === sectionId) {
        return {
          ...sec,
          items: (sec.items || []).filter((item: any) => item.id !== itemId)
        };
      }
      return sec;
    });
    onChangeSections(updated);
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2.5 }}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 700, color: '#29456c', fontSize: '0.9rem' }}>
          Struttura Sezioni ed Elementi Checklist
        </Typography>
        <Button
          size="small"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleAddSection}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '6px',
            fontSize: '0.8rem',
            color: '#29456c',
            borderColor: '#29456c',
            '&:hover': {
              borderColor: '#2578b0',
              color: '#2578b0',
              backgroundColor: 'rgba(37, 120, 176, 0.04)'
            }
          }}>
          Aggiungi Sezione
        </Button>
      </Stack>

      {sections.map((section) => {
        const initialSection = {
          ...section,
          items: (section.items || []).map((item: any) => ({
            ...item,
            name: item.name || item.description || ''
          }))
        };

        return (
          <EditableSectionNode
            key={section.id}
            section={initialSection}
            onRenameSection={handleRenameSection}
            onRemoveSection={handleRemoveSection}
            onRenameItem={handleRenameItem}
            onAddItemToSection={handleAddItemToSection}
            onRemoveItemFromSection={handleRemoveItemFromSection}
          />
        );
      })}

      {sections.length === 0 && (
        <Typography
          variant="body2"
          sx={{ color: '#94a3b8', textAlign: 'center', my: 4, fontStyle: 'italic' }}>
          Nessuna sezione presente. Clicca su Aggiungi Sezione per iniziare a comporre il template.
        </Typography>
      )}
    </Box>
  );
};
